import { GetAllCoursesFromEntityUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';

import { CourseApiCodeInput } from '../../../components/entity-settings/tabs-contents/courses-tab-content/course-api-code-input';

export const makeCoursesFromEntityListColumns = (): TableColumn<
  GetAllCoursesFromEntityUseCaseInterface.Result[number]
>[] => {
  return [
    {
      name: 'Curso',
      width: '40%',
      sortable: true,
      selector: (row) => row.course,
    },
    {
      name: 'Código API',
      selector: (row) => row.apiCode,
      cell: (row) => (
        <CourseApiCodeInput apiCode={row?.apiCode} relationshipId={row?.id} />
      ),
    },
  ];
};
